module.exports = __webpack_public_path__ + "img/undraw_meditation_re_gll0.3b90b3e4.svg";